export function getIconByName(name: string): any {
  let lowerCaseName = name.toLowerCase();
  let lowerCaseNameWithS = lowerCaseName + "s";
  switch (lowerCaseName || lowerCaseNameWithS) {
    case "tomato":
      return "🍅";
    case "apple":
      return "🍎";
    case "banana":
      return "🍌";
    case "orange":
      return "🍊";
    case "strawberry":
      return "🍓";
    case "watermelon":
      return "🍉";
    // Add more vegetables here
    case "carrot":
      return "🥕";
    case "broccoli":
      return "🥦";
    case "cucumber":
      return "🥒";
    case "potato":
      return "🥔";
    // Add more vegetables here
    case "eggplant":
      return "🍆";
    case "pepper":
      return "🌶️";
    case "corn":
      return "🌽";
    case "onion":
      return "🧅";
    case "garlic":
      return "🧄";
    // Add more vegetables here
    case "lettuce":
      return "🥬";
    case "spinach":
      return "🥬";
    case "zucchini":
      return "🥒";
    case "radish":
      return "🥕";
    case "beetroot":
      return "🍆";
    // Add more vegetables here
    case "asparagus":
      return "🌱";
    case "celery":
      return "🌿";
    case "mushroom":
      return "🍄";
    case "peas":
      return "🌱";
    case "artichoke":
      return "🌿";
    // Add more fruits here
    case "grape":
      return "🍇";
    case "cherry":
      return "🍒";
    case "pear":
      return "🍐";
    case "peach":
      return "🍑";
    case "kiwi":
      return "🥝";
    case "mango":
      return "🥭";
    case "pineapple":
      return "🍍";
    case "lemon":
      return "🍋";
    case "grapefruit":
      return "🍊";
    case "blueberry":
      return "🫐";
    case "raspberry":
      return "🍇";
    case "blackberry":
      return "🍇";
    case "pomegranate":
      return "🍎";
    case "apricot":
      return "🍑";
    case "plum":
      return "🍑";
    case "nectarine":
      return "🍑";
    case "fig":
      return "🍑";
    case "coconut":
      return "🥥";
    case "avocado":
      return "🥑";
    case "lime":
      return "🍈";
    case "passion fruit":
      return "🍈";
    case "dragon fruit":
      return "🐉";
    // Add more fruits here
    case "milk":
      return "🥛";
    case "cheese":
      return "🧀";
    case "yogurt":
      return "🥣";
    case "butter":
      return "🧈";
    // Add more dairy items here
    case "cream":
      return "🥛";
    case "sour cream":
      return "🥛";
    case "whipped cream":
      return "🥛";
    case "milkshake":
      return "🥛";
    case "ice cream":
      return "🍦";
    case "frozen yogurt":
      return "🍦";
    case "cheeseburger":
      return "🍔";
    case "pizza":
      return "🍕";
    case "sandwich":
      return "🥪";
    case "cheese fries":
      return "🍟";
    case "cheese fondue":
      return "🍲";
    case "cheese soup":
      return "🍲";
    case "cheese omelette":
      return "🍳";
    case "cheese toast":
      return "🍞";
    case "cheese crackers":
      return "🍪";
    case "cheese cake":
      return "🍰";
    case "cheese Danish":
      return "🥐";
    case "cheese croissant":
      return "🥐";
    case "cheese strudel":
      return "🥐";
    case "cheese roll":
      return "🥐";
    case "cheese soufflé":
      return "🥐";
    case "bread":
      return "🍞";
    case "baguette":
      return "🥖";
    case "croissant":
      return "🥐";
    case "pancake":
      return "🥞";
    case "waffle":
      return "🧇";
    case "french toast":
      return "🍞";
    case "muffin":
      return "🧁";
    // Add more meats here
    case "chicken":
      return "🍗";
    case "egg":
      return "🥚";
    case "beef":
      return "🥩";
    case "pork":
      return "🐖";
    case "lamb":
      return "🐑";
    case "fish":
      return "🐟";
    case "shrimp":
      return "🍤";
    case "bacon":
      return "🥓";
    case "sausage":
      return "🌭";
    case "ham":
      return "🍖";
    case "turkey":
      return "🦃";
    case "duck":
      return "🦆";
    case "venison":
      return "🦌";
    // Add more meats here
    default:
      return "🍇";
  }
}
